var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTimeOut24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_time_out24x24",
    transform: "translate(-4.992 -5.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22643",
    "data-name": "Group 22643",
    transform: "translate(4.992 5.998)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_389_",
    d: "M17.957,19.03a6.4,6.4,0,0,0-2.044-4,7.236,7.236,0,0,0-3.472-1.765v-.827a1.11,1.11,0,0,0,.9-1.216,1.143,1.143,0,0,0-1.187-.965H9.622a1.143,1.143,0,0,0-1.187.965,1.11,1.11,0,0,0,.9,1.216v.829a7.234,7.234,0,0,0-3.461,1.763,6.8,6.8,0,0,0-.6.628H2.744a.346.346,0,0,0-.308.159.312.312,0,0,0,0,.334.346.346,0,0,0,.308.159H4.8a6.311,6.311,0,0,0-.624,1.251H.348a.346.346,0,0,0-.308.159.312.312,0,0,0,0,.333.346.346,0,0,0,.308.159H3.975A6.156,6.156,0,0,0,3.8,19.467H2.246a.346.346,0,0,0-.308.159.312.312,0,0,0,0,.333.346.346,0,0,0,.308.159H3.812a6.161,6.161,0,0,0,.22,1.251H1.754a.346.346,0,0,0-.308.159.312.312,0,0,0,0,.333.346.346,0,0,0,.308.159h2.5a6.508,6.508,0,0,0,1.62,2.316,7.361,7.361,0,0,0,4.319,1.894q.349.032.7.032a7.535,7.535,0,0,0,3.874-1.06.321.321,0,0,0,.152-.2.308.308,0,0,0-.049-.246.371.371,0,0,0-.486-.1,6.813,6.813,0,0,1-8.009-.78,5.625,5.625,0,0,1,0-8.378,6.772,6.772,0,0,1,9.047,0,5.624,5.624,0,0,1,.846,7.411.307.307,0,0,0-.049.246.321.321,0,0,0,.152.2.371.371,0,0,0,.486-.1,6.22,6.22,0,0,0,1.1-4.232ZM9.13,11.369a.475.475,0,0,1,.492-.457h2.531a.458.458,0,1,1,0,.914H9.622a.475.475,0,0,1-.492-.457Zm.906,1.791v-.686h1.7v.686a7.729,7.729,0,0,0-1.7,0Z",
    transform: "translate(.008 -10.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_391_",
    d: "M436.123,425.5a.361.361,0,0,0-.249.1.336.336,0,0,0,0,.485.361.361,0,0,0,.5,0,.336.336,0,0,0,0-.485A.361.361,0,0,0,436.123,425.5Z",
    transform: "translate(-420.458 -412.116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_394_",
    d: "M160.541,144.609a5.037,5.037,0,1,0,5.47,5.024A5.269,5.269,0,0,0,160.541,144.609Zm0,9.4a4.387,4.387,0,1,1,4.765-4.377A4.59,4.59,0,0,1,160.541,154.009Z",
    transform: "translate(-149.663 -140.266)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_397_",
    d: "M261.134,219.512l-1.745,1.7a1.121,1.121,0,0,0-.968,0l-.782-.76a.361.361,0,0,0-.5,0,.336.336,0,0,0,0,.485l.782.76a1.034,1.034,0,0,0-.113.471,1.1,1.1,0,0,0,2.192,0,1.035,1.035,0,0,0-.113-.471l1.7-1.648h0l.051-.05a.336.336,0,0,0,0-.485.361.361,0,0,0-.5,0Zm-2.231,3.033a.38.38,0,1,1,.391-.38.386.386,0,0,1-.39.38Z",
    transform: "translate(-248.008 -212.71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_398_",
    d: "M398.331,289.86H398a.343.343,0,1,0,0,.685h.327a.343.343,0,1,0,0-.685Z",
    transform: "translate(-383.674 -280.779)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_399_",
    d: "M193.758,289.616h-.327a.343.343,0,1,0,0,.685h.327a.343.343,0,1,0,0-.685Z",
    transform: "translate(-186.289 -280.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_400_",
    d: "M300.476,183.815a.348.348,0,0,0,.353-.343v-.318a.353.353,0,1,0-.705,0v.318A.348.348,0,0,0,300.476,183.815Z",
    transform: "translate(-289.571 -177.214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_424_",
    d: "M300.232,387.393a.348.348,0,0,0-.353.343v.318a.353.353,0,1,0,.705,0v-.318A.348.348,0,0,0,300.232,387.393Z",
    transform: "translate(-289.336 -375.159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_425_",
    d: "M.353,351.44a.361.361,0,0,0-.249.1.336.336,0,0,0,0,.485.361.361,0,0,0,.5,0,.336.336,0,0,0,0-.485.361.361,0,0,0-.249-.1Z",
    transform: "translate(.005 -340.359)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTimeOut24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_time_out24x24.778a670cf9913e3e7bb41f3fa32ff183.svg";